"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles = (theme) => ({
    root: {
        height: '100%',
        position: 'relative',
        top: -6,
    },
    flexWrap: {
        display: 'flex',
        position: 'relative',
        top: '-5px', // rise up into the padding a bit
    },
    sectionTitle: {
        color: theme.palette.text.strong,
        fontSize: '14px',
        fontWeight: '500',
        letterSpacing: '-0.3px',
        lineHeight: '20px',
        textAlign: 'left',
    },
    listItemDense: {
        paddingTop: 6,
        paddingBottom: 10,
    },
    topHeaderRow: {
        fontSize: '14px',
        fontWeight: 500,
        color: theme.palette.text.strong,
    },
    divider: {
        margin: '2px 0 4px',
    },
    topHoldingsListItemRoot: {
        marginTop: -17,
    },
    topHoldingsListItemDefault: {
        paddingTop: 0,
        paddingBottom: 8,
    },
    companyName: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        color: theme.palette.text.strong,
        fontSize: '12px',
        fontWeight: 500,
        position: 'relative',
        top: 2,
    },
    tickerSymbol: {
        color: theme.palette.text.secondary,
        fontSize: '12px',
        position: 'relative',
        top: 2,
    },
});
exports.default = styles;
